import { apiGet, apiPost } from "../../../components/Common/Axios";
import { useEffect, useState } from "react";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Setting } from "lib/models";
import toast from "react-hot-toast";
import { FormCard } from "components/Layout/PageShell";

function SettingSystem() {
  const [setting, setSetting] = useState<Setting | undefined>(undefined);

  const loadSetting = async () => {
    const result = await apiGet("/setting");
    if (result.error) {
      toast.error("시스템 설정을 불러오는데 실패했습니다.");
      return;
    }
    setSetting(result.data);
  };

  useEffect(() => {
    loadSetting();
  }, []);

  const handleUpdate = async () => {
    const result = await apiPost("/setting", setting);
    if (result.error) {
      toast.error("시스템 설정을 변경하는데 실패했습니다.");
      return;
    }
    toast.success("시스템 설정이 변경되었습니다.");
  };

  if (!setting) {
    return null;
  }

  return (
    <FormCard>
      <div className="text-xl font-semibold pb-1">시스템 설정</div>
      <div className="text-sm text-gray-500 pb-8">
        시스템에서 사용하는 값을 설정합니다.
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-[120px_minmax(0,400px)] gap-x-3 gap-y-2 text-base items-center">
        <div className="text-left sm:text-right">회사명</div>
        <div>
          <Input
            value={setting.companyName}
            onChange={(e) =>
              setSetting({ ...setting, companyName: e.target.value })
            }
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div className="text-left sm:text-right">사업자등록번호</div>
        <div>
          <Input
            value={setting.businessNo}
            onChange={(e) =>
              setSetting({ ...setting, businessNo: e.target.value })
            }
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div className="text-left sm:text-right">대표자</div>
        <div>
          <Input
            value={setting.ceoName}
            onChange={(e) =>
              setSetting({ ...setting, ceoName: e.target.value })
            }
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div className="text-left sm:text-right">주소</div>
        <div>
          <Input
            value={setting.address}
            onChange={(e) =>
              setSetting({ ...setting, address: e.target.value })
            }
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div className="text-left sm:text-right">E-mail</div>
        <div>
          <Input
            value={setting.email}
            onChange={(e) => setSetting({ ...setting, email: e.target.value })}
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div className="text-left sm:text-right">업태</div>
        <div>
          <Input
            value={setting.bussinessType}
            onChange={(e) =>
              setSetting({ ...setting, bussinessType: e.target.value })
            }
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div className="text-left sm:text-right">종목</div>
        <div>
          <Input
            value={setting.bussinessItem}
            onChange={(e) =>
              setSetting({ ...setting, bussinessItem: e.target.value })
            }
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div></div>
        <Button size="md" variant="primary" onClick={() => handleUpdate()}>
          변경
        </Button>
      </div>
    </FormCard>
  );
}

export default SettingSystem;
